import { api } from '../http';

export const getAuctionImpugnations = auctionId => api.get(`/auctions/${auctionId}/impugnations`);
export const createAuctionImpugnation = (auctionId, data) =>
  api.post(`/auctions/${auctionId}/impugnations`, data);
export const answerAuctionImpugnation = (auctionId, impugnationId, data) =>
  api.patch(`/auctions/${auctionId}/impugnations/${impugnationId}`, data);
